import { onBeforeUnmount, readonly, ref, watch } from 'vue';

import type { Ref } from 'vue';

const active = ref(false);

/**
 * Идёт ли на странице раунд тренажёра. Оболочка прячет на это время всё, что
 * не относится к вопросу (ссылки на соседние страницы): на телефоне с открытой
 * клавиатурой каждая строка экрана на счету.
 */
export const isFocusMode = readonly(active);

/** Страница держит режим фокуса, пока `on` истинно и пока она на экране. */
export function useFocusMode(on: Ref<boolean>) {
  watch(on, (value) => {
    active.value = value;
  }, { immediate: true });

  onBeforeUnmount(() => {
    active.value = false;
  });
}
